import React, { createContext, useContext, ReactNode } from 'react';
import { SectionType } from '../types';

interface FormModeContextType {
  mode: 'static' | 'dynamic';
  applicationId?: string;
  onSave?: (sectionData: any, sectionType: SectionType) => Promise<void>;
  autoSaveEnabled?: boolean;
  isLoading?: boolean;
  lastSaved?: Date | null;
  createdAt?: string;
  submittedAt?: string | null;
}

interface FormModeProviderProps {
  mode: 'static' | 'dynamic';
  applicationId?: string;
  onSave?: (sectionData: any, sectionType: SectionType) => Promise<void>;
  autoSaveEnabled?: boolean;
  isLoading?: boolean;
  lastSaved?: Date | null;
  createdAt?: string;
  submittedAt?: string | null;
  children: ReactNode;
}

const FormModeContext = createContext<FormModeContextType | undefined>(undefined);

export const FormModeProvider: React.FC<FormModeProviderProps> = ({
  mode,
  applicationId,
  onSave,
  autoSaveEnabled = false,
  isLoading = false,
  lastSaved = null,
  createdAt,
  submittedAt,
  children,
}) => {
  const contextValue: FormModeContextType = {
    mode,
    applicationId,
    onSave,
    autoSaveEnabled,
    isLoading,
    lastSaved,
    createdAt,
    submittedAt,
  };

  return (
    <FormModeContext.Provider value={contextValue}>
      {children}
    </FormModeContext.Provider>
  );
};

export const useFormMode = (): FormModeContextType => {
  const context = useContext(FormModeContext);
  if (context === undefined) {
    throw new Error('useFormMode must be used within a FormModeProvider');
  }
  return context;
};

export default FormModeContext;